import React from 'react'
import { Button, SFXS } from '@orbital/games-frontend-library'
import { Wrapper } from './styled'
import { BetsRemained } from './styled'
import { ReactComponent as InfiniteSVG } from './Vector.svg'

export default function AutoCancelFooter({ footerState, betsRemained, funcStop, disable }: any) {
    return (
        <Wrapper footerState={footerState === 'cancelAuto'}>
            <section>
                <Button width="237px"
                    textColor="#ffbb00;"
                    func={(b: boolean) => b && funcStop()}
                    background='transparent'
                    SFX={SFXS.goBackSFX}
                    customClass={disable && "disable"}
                >
                    CANCEL AUTO
                </Button>
                <BetsRemained>
                    {betsRemained}
                    {betsRemained === '' && <InfiniteSVG className='infinite' />}
                </BetsRemained>
            </section>
        </Wrapper>
    )
}
